/**
 * Mock - influencers: creator profiles, platform/industry breakdowns.
 * Per-domain mutable state lives in ./db.ts (never in the shared mock/db.ts).
 */
import type { InfluencersApi } from '@/data-sources/contract';

export const mockInfluencersApi: InfluencersApi = {};
